<template lang="html">
  <div class="">
    <button class="btn btn-success" type="button" name="button" @click="show">progress</button>
    <modal :name="'printline-modal'+line.rowid">
      <div class="modal-header">
          <h4 class="text-left" style="">Impression de la ligne {{line.rowid}}</h4>
      </div>
      <div class="modal-body">
        <div class="col-12">
          <div class="form-group">
            <label for="">
              Quantité produite :
              <input type="number" class="form-control" v-model="qtyprinted">
            </label>
          </div>
          <div class="form-group">
            <label for="">
              Gâche :
              <input type="number" class="form-control" v-model="qtyperte">
            </label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success" type="button" @click="setPrinted" name="button">
          <i class="fas fa-check"></i>
          Valider
        </button>
        <button class="btn btn-default" type="button" @click="hide" name="button">
          Annuler
        </button>
      </div>




  </modal>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: "Impression",
  props : [
    "line"
  ],
  data() {
    return {
      qtyprinted: 0,
      qtyperte :0,
    };
  },
  methods: {
    show () {
         this.$modal.show('printline-modal'+this.line.rowid);
    },
    hide () {
          this.$modal.hide('printline-modal'+this.line.rowid);
    },
    setPrinted() {
      var newQty = parseFloat(this.line.qty_used) + parseFloat(this.qtyprinted);
      var postedVar = {
        "line_id": this.line.rowid,
        "newqty": newQty,
        "perte" : parseFloat(this.qtyperte),
      }
      console.log(postedVar);
      axios
        .post(
          "https://crm.bonbonprint.fr/api/index.php/of/setprintqty",
          postedVar,
          {
            headers: {
              'DOLAPIKEY': 'bb30b37967cc61e97da43f53467e94ca1c0fabf9'
            }
          }
        )
        .then(response => {
          console.log(response);
          this.qtyperte = 0;
          this.qtyprinted = 0;
          //if first print set start date
          this.$emit('impressiondone',response);
          this.hide();
        });
    }
  },
}
</script>

<style lang="css" scoped>
.thumb-preview-item img{
  max-width: 200px;
  max-height: 200px;
}


</style>
<style media="screen">
.vm--modal{
  top: 10% !important;
  left: 15% !important;
  width: 80% !important;
  height: 80% !important;
}
</style>
